import React, { useContext, useEffect, useState, useRef } from 'react';
import { Card, Grid, Typography, FormControlLabel, FormControl, RadioGroup, Radio, TextField, MenuItem, Checkbox, InputAdornment, IconButton } from '@mui/material';
import { Box } from '@mui/system';
import { useLocation, useParams } from 'react-router-dom';
import useStyles from './indexcss';
import { getServices, getServicesById, postQuestionnaire, getEventServicesById, postEventQuestionnaire, submitEventQuestionnaire } from '../../../../Utils/apiService';
import KenLoader from '../../../../GlobalComponents/KenLoader';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { AppButton } from '../../../../Components/AppButton';
import KenColors from '../../../../Helpers/Themes/kenColors';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { enqueueSnackbar } from 'notistack';
import { AuthUser } from '../../../../interfaces/Contexts';
import { AuthContext } from '../../../../Helpers/Contexts/authContext';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { getregisteredevents } from '../../utils/services';
import Slider from '@mui/material/Slider';

const EventFeedback: React.FunctionComponent<{ eventId: string, onClose: () => void }> = ({ eventId, onClose }) => {
  const location = useLocation();
  const { state } = location;
  const classes = useStyles();
  const {
    state: { user },
    dispatch,
  } = useContext(AuthContext);
  const { serviceId } = useParams<{ serviceId: string }>();
  const [serviceData, setServiceData] = useState([]);
  const [serviceDataName, setServiceDataName] = useState();
  const [serviceDataQuestion, setServiceDataQuestion] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [shortAnsValues, setShortAnsValues] = useState<any[]>([]);
  const [tempValues, setTempValues] = useState<any[]>([]);
  const userData = user as AuthUser;
  const [dropdownOption, setDropdownOption] = useState('');
  const [dropdownOptionValue, setDropdownOptionValue] = useState<any[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [selectMultipleOption, setSelectMultipleOption] = useState<any[]>([]);
  const [fileName, setFileName] = useState<string | null>(null);
  const [fileName1, setFileName1] = useState<any[]>([]);
  const [selectedValue, setSelectedValue] = useState<string | null>(null);
  const [selectedValue1, setSelectedValue1] = useState<any[]>([]);
  const [validationErrors, setValidationErrors] = useState<any>({});
  const [linearScaleValues, setLinearScaleValues] = useState<any[]>([]);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>, questionData: any) => {
    const inputValue = event.target.value;
    setSelectedValue(event.target.value);
    const updatedQuestionData = {
      ...questionData,
      value: inputValue,
    };
    setSelectedValue1((prevValues) => {
      const existingIndex = prevValues.findIndex((item) => item.Id === questionData.Id);
      if (existingIndex !== -1) {
        const updatedValues = [...prevValues];
        updatedValues[existingIndex] = updatedQuestionData;
        return updatedValues;
      } else {
        return [...prevValues, updatedQuestionData];
      }
    });
    setValidationErrors((prevErrors:any) => {
      const { [questionData.Id]: _, ...rest } = prevErrors;
      return rest;
    });
  };

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>, questionData: any) => {
    const file: any = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64File = reader.result as string;
        const base64 = base64File.split(',');
        setFileName(file.name);
        const updatedQuestionData = {
          ...questionData,
          value: base64[1],
        };
        setFileName1((prevValues) => {
          const existingIndex = prevValues.findIndex((item) => item.Id === questionData.Id);
          if (existingIndex !== -1) {
            const updatedValues = [...prevValues];
            updatedValues[existingIndex] = updatedQuestionData;
            return updatedValues;
          } else {
            return [...prevValues, updatedQuestionData];
          }
        });
      };
      reader.readAsDataURL(file);
    }
    setValidationErrors((prevErrors:any) => {
      const { [questionData.Id]: _, ...rest } = prevErrors;
      return rest;
    });
  };

  const handleIconClick = () => {
    fileInputRef.current?.click();
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, questionData: any) => {
    const value = event.target.name;
    setSelectedOptions((prev) => (prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]));
    const updatedQuestionData = {
      ...questionData,
      value: selectedOptions.includes(value) ? selectedOptions.filter((v) => v !== value) : [...selectedOptions, value],
    };
    setSelectMultipleOption((prevValues) => {
      const existingIndex = prevValues.findIndex((item) => item.Id === questionData.Id);
      if (existingIndex !== -1) {
        const updatedValues = [...prevValues];
        updatedValues[existingIndex] = updatedQuestionData;
        return updatedValues;
      } else {
        return [...prevValues, updatedQuestionData];
      }
    });
    setValidationErrors((prevErrors:any) => {
      const { [questionData.Id]: _, ...rest } = prevErrors;
      return rest;
    });
  };

  const handleChangeDropdown = (event: SelectChangeEvent, questionData: any) => {
    const inputValue = event.target.value;
    setDropdownOption(event.target.value as string);
    const updatedQuestionData = {
      ...questionData,
      value: inputValue,
    };
    setDropdownOptionValue((prevValues) => {
      const existingIndex = prevValues.findIndex((item) => item.Id === questionData.Id);
      if (existingIndex !== -1) {
        const updatedValues = [...prevValues];
        updatedValues[existingIndex] = updatedQuestionData;
        return updatedValues;
      } else {
        return [...prevValues, updatedQuestionData];
      }
    });
    setValidationErrors((prevErrors:any) => {
      const { [questionData.Id]: _, ...rest } = prevErrors;
      return rest;
    });
  };

  const handleLinearScaleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, questionData: any) => {
    const inputValue = event.target.value;
    const updatedQuestionData = {
      ...questionData,
      value: inputValue,
    };
    setLinearScaleValues((prevValues) => {
      const existingIndex = prevValues.findIndex((item) => item.Id === questionData.Id);
      if (existingIndex !== -1) {
        const updatedValues = [...prevValues];
        updatedValues[existingIndex] = updatedQuestionData;
        return updatedValues;
      } else {
        return [...prevValues, updatedQuestionData];
      }
    });
    setValidationErrors((prevErrors:any) => {
      const { [questionData.Id]: _, ...rest } = prevErrors;
      return rest;
    });
  };

  useEffect(() => {
    setLoading(true);
    if (eventId) {
      
      
      getregisteredevents(userData?.applicantId)
        .then(async (res: any) => {
          let response = res?.result?.data;
          if (res?.status) {
            // Filter out objects where questionnaire is null
            let eventData = response.filter((val: any) => val.questionnaire !== null);
            if (eventData.length > 0) {
              setServiceData(eventData);
              setServiceDataQuestion(eventData[0]);
            } else {
              console.warn("No valid eventData found with questionnaire.");
            }
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.error(err);
        });
    }
    // getServices()
    //   .then(async (res: any) => {
    //     if (res?.success) {
    //       res.data.map((val: any) => {
    //         if (val?.id == serviceId) {
    //           setServiceDataName(val?.name);
    //         }
    //       });
    //     }
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //   });
  }, []);

  const handleShortValues = (event: any, questionData: any) => {
    const inputValue = event;
    const updatedQuestionData = {
      ...questionData,
      value: inputValue,
    };
    setShortAnsValues((prevValues) => {
      const existingIndex = prevValues.findIndex((item) => item.Id === questionData.Id);
      if (existingIndex !== -1) {
        const updatedValues = [...prevValues];
        updatedValues[existingIndex] = updatedQuestionData;
        return updatedValues;
      } else {
        return [...prevValues, updatedQuestionData];
      }
    });
    setValidationErrors((prevErrors:any) => {
      const { [questionData.Id]: _, ...rest } = prevErrors;
      return rest;
    });
  };

  const handleSubmit = () => {
    let errors: any = {};
    serviceDataQuestion?.questionnaire?.forEach((question: any) => {
      if (question.Is_Required__c) {
        if (question.Question_Type__c === 'Short Answer' && !shortAnsValues.find(item => item.Id === question.Id)?.value) {
          errors[question.Id] = 'Field is Required';
        }
        if (question.Question_Type__c === 'Dropdown' && !dropdownOption) {
          errors[question.Id] = 'Field is Required';
        }
        if (question.Question_Type__c === 'Yes/No' && !selectedValue) {
          errors[question.Id] = 'Field is Required';
        }
        if (question.Question_Type__c === 'Multiple Choice' && selectedOptions.length === 0) {
          errors[question.Id] = 'Field is Required';
        }
        if (question.Question_Type__c === 'File Upload' && !fileName) {
          errors[question.Id] = 'Field is Required';
        }
        if (question.Question_Type__c === 'Linear Scale' && !linearScaleValues.find(item => item.Id === question.Id)?.value) {
          errors[question.Id] = 'Field is Required';
        }
      }
    });

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    // Check if applicantId starts with "001" to determine the correct key
    const isAccount = userData.applicantId?.substring(0, 3) === '001';
    const respondentKey = isAccount ? 'Account__c' : 'Respondent__c';

    const shortAnsValuesResponses = shortAnsValues.map((question: any) => ({
      [respondentKey]: userData.applicantId,
      Questionnaire_Parameter__c: question.Id,
      Response__c: question.value,
      Session__c:eventId
    }));

    const dropdownOptionResponse = dropdownOptionValue.map((question: any) => ({
      [respondentKey]: userData.applicantId,
      Questionnaire_Parameter__c: question.Id,
      Response__c: question.value,
      Session__c:eventId
    }));

    const selectMultipleOptionResponse = selectMultipleOption.map((question: any) => ({
      [respondentKey]: userData.applicantId,
      Questionnaire_Parameter__c: question.Id,
      Response__c: question.value.join(';'),
      Session__c:eventId
    }));

    const fileNameResponse = fileName1.map((question: any) => ({
      [respondentKey]: userData.applicantId,
      Questionnaire_Parameter__c: question.Id,
      Response__c: question.value,
      Session__c:eventId
    }));

    const selectedValueResponse = selectedValue1.map((question: any) => ({
      [respondentKey]: userData.applicantId,
      Questionnaire_Parameter__c: question.Id,
      Response__c: question.value,
      Session__c:eventId
    }));

    const linearScaleResponses = linearScaleValues.map((question: any) => ({
      [respondentKey]: userData.applicantId,
      Questionnaire_Parameter__c: question.Id,
      Response__c: question.value,
      Session__c:eventId
    }));

    let payload: any = [
      ...shortAnsValuesResponses,
      ...dropdownOptionResponse,
      ...selectMultipleOptionResponse,
      ...fileNameResponse,
      ...selectedValueResponse,
      ...linearScaleResponses,

    ];

    submitEventQuestionnaire(payload)
      .then((res:any) => {
        if (res?.result?.success) {
          enqueueSnackbar({ message: 'Feedback Submitted Sucessfully', variant: 'success', autoHideDuration: 1000 });
          handleCancelClick();
        } else {
          enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        }
      })
      .catch((err:any) => {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        console.error(err);
      });
  };

  const handleCancelClick = () => {
    onClose();
    setDropdownOption('');
    setSelectedValue('');
    setSelectedOptions([]);
    setFileName('');
  };

  return (
    <>
      {loading ? (
        <KenLoader />
      ) : (
        <Grid container spacing={2} >
          <Grid item xs={6} md={6} lg={6}>
            <Card sx={{ height: '50vh' }} className={classes.RequestMainCard1}>
              <Typography
                sx={{
                  fontSize: '15px',
                  fontWeight: 600,
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '12px !important',
                  },
                }}
              >
                {serviceDataName}{' '}
              </Typography>
              <hr style={{ border: '1px solid #BFCEFF' }} />
              {serviceData.map((value: any, index: number) => {
                return (
                  <>
                    <Grid container spacing={2} sx={{ cursor: 'pointer' }} onClick={() => setServiceDataQuestion(value)}>
                      <Grid item xs={8}>
                        <Typography
                          sx={{
                            fontSize: '12px',
                            fontWeight: 500,
                            color: serviceDataQuestion.length == 0 && index == 0 ? '#3061FF' : serviceDataQuestion?.id == value?.id ? '#3061FF' : '#373A45',
                            '@media (min-width: 1280px) and (max-width: 1300px)': {
                              fontSize: '10px !important',
                            },
                          }}
                        >
                          {value?.eventTitle}
                        </Typography>
                      </Grid>
                      <Grid item xs={4} display={'flex'} justifyContent={'end'}>
                        <KeyboardArrowRightIcon style={{ fontSize: '15px' }} />
                      </Grid>
                    </Grid>
                    <hr style={{ border: '1px solid #B2B3B7' }} />
                  </>
                );
              })}
            </Card>
          </Grid>
          <Grid item xs={6} md={6} lg={6}>
            <Card sx={{ height: '70vh' }} className={classes.RequestMainCard1}>
              <Typography
                sx={{
                  fontSize: '15px',
                  fontWeight: 500,
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '12px !important',
                  },
                }}
              >
                {serviceDataQuestion.eventTitle}
              </Typography>
              <hr style={{ border: '1px solid #BFCEFF' }} />
              <Box
                sx={{
                  height: '50vh', // Reduced height
                  overflowY: 'auto', // Enable vertical scrolling
                  '@media (min-width: 1920px) and (max-width: 1940px)': {
                    height: '25vh !important',
                  },
                  '@media (min-width: 1536px) and (max-width: 1636px)': {
                    height: '20vh !important',
                  },
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    height: '15vh !important',
                  },
                  '@media (min-width: 1440px) and (max-width: 1500px)': {
                    height: '22vh !important',
                  },
                }}
                className="scrollbar-cusgray"
              >
                {serviceDataQuestion?.questionnaire?.length > 0 ? (
                  serviceDataQuestion?.questionnaire?.map((val: any, index: number) => {
                    let option: any = [];
                    if (val.Question_Type__c === 'Dropdown') {
                      option = val.MCQ_Options__c.split(',').map((opt: any) => opt.trim());
                    }
                    let option1: any = [];
                    if (val.Question_Type__c === 'Multiple Choice') {
                      option1 = val.MCQ_Options__c.split(';').map((opt: any) => opt.trim());
                    }
                    return (
                      <>
                        {val.Question_Type__c === 'Short Answer' && (
                          <>
                            <Typography sx={{ fontSize: '10.5px', fontWeight: 500, marginTop: '10px' }}>{val.Question_Label__c}</Typography>
                            <TextField
                              id="outlined-basic"
                              variant="outlined"
                              placeholder="Short Answer"
                              value={shortAnsValues.find(item => item.Id === val.Id)?.value || ''}
                              sx={{
                                marginTop: '10px',
                                width: '100%',
                                height: '36px',
                                '& .MuiInputBase-root': {
                                  fontSize: '12px',
                                  height: '36px',
                                },
                                '& .MuiInputLabel-root': {
                                  fontSize: '12px',
                                },
                              }}
                              onChange={(e) => handleShortValues(e.target.value, val)}
                            />
                            {validationErrors[val.Id] && (
                              <Typography sx={{ color: 'red', mt: 1, fontSize: '11px' }}>{validationErrors[val.Id]}</Typography>
                            )}
                          </>
                        )}
                        {val.Question_Type__c === 'Dropdown' && (
                          <>
                            <Typography sx={{ fontSize: '10.5px', fontWeight: 500, marginTop: '10px' }}>{val.Question_Label__c}</Typography>
                            <FormControl fullWidth sx={{ width: '100%', height: '36px', marginTop: '10px' }}>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={dropdownOption}
                                onChange={(event: any) => handleChangeDropdown(event, val)}
                                sx={{
                                  fontSize: '12px',
                                  height: '36px',
                                  '& .MuiSelect-select': {
                                    fontSize: '12px',
                                  },
                                }}
                              >
                                {option.map((values: any) => {
                                  return <MenuItem value={values}>{values}</MenuItem>;
                                })}
                              </Select>
                            </FormControl>
                            {validationErrors[val.Id] && (
                              <Typography sx={{ color: 'red', mt: 1, fontSize: '11px' }}>{validationErrors[val.Id]}</Typography>
                            )}
                          </>
                        )}
                        {val.Question_Type__c === 'Yes/No' && (
                          <div key={index} style={{ marginTop: '10px' }}>
                            <Typography sx={{ fontSize: '10.5px', fontWeight: 500 }}>{val.Question_Label__c}</Typography>
                            <RadioGroup aria-labelledby="demo-radio-buttons-group-label" value={selectedValue} name="radio-buttons-group" onChange={(event: any) => handleRadioChange(event, val)}>
                              <FormControlLabel
                                value="Yes"
                                control={
                                  <Radio
                                    sx={{
                                      '& .MuiSvgIcon-root': {
                                        fontSize: '15px',
                                      },
                                    }}
                                  />
                                }
                                label="Yes"
                                sx={{
                                  '& .MuiFormControlLabel-label': {
                                    fontSize: '12px',
                                  },
                                }}
                              />
                              <FormControlLabel
                                value="No"
                                control={
                                  <Radio
                                    sx={{
                                      '& .MuiSvgIcon-root': {
                                        fontSize: '15px',
                                      },
                                    }}
                                  />
                                }
                                label="No"
                                sx={{
                                  '& .MuiFormControlLabel-label': {
                                    fontSize: '12px',
                                  },
                                }}
                              />
                            </RadioGroup>
                            {validationErrors[val.Id] && (
                              <Typography sx={{ color: 'red', mt: 1, fontSize: '11px' }}>{validationErrors[val.Id]}</Typography>
                            )}
                          </div>
                        )}
                        {val.Question_Type__c === 'Multiple Choice' && (
                          <div key={index} style={{ marginTop: '10px' }}>
                            <Typography sx={{ fontSize: '10.5px', fontWeight: 500 }}>{val.Question_Label__c}</Typography>
                            {option1.map((option: any) => (
                              <FormControlLabel
                                key={option}
                                control={
                                  <Checkbox
                                    name={option}
                                    checked={selectedOptions.includes(option)}
                                    onChange={(event) => handleCheckboxChange(event, val)}
                                    sx={{
                                      marginLeft: '5px',
                                      transform: 'scale(1.2)',
                                      '& .MuiSvgIcon-root': { fontSize: '12px' },
                                    }}
                                  />
                                }
                                label={<Typography sx={{ fontSize: '12px' }}> {option}</Typography>}
                              />
                            ))}
                            {validationErrors[val.Id] && (
                              <Typography sx={{ color: 'red', mt: 1, fontSize: '11px' }}>{validationErrors[val.Id]}</Typography>
                            )}
                          </div>
                        )}
                        {val.Question_Type__c === 'File Upload' && (
                          <div key={index} style={{ marginTop: '10px' }}>
                            <Typography sx={{ fontSize: '10.5px', fontWeight: 500 }}>{val.Question_Label__c}</Typography>
                            <TextField
                              label="Upload File"
                              variant="outlined"
                              value={fileName || ''}
                              placeholder="Choose a file"
                              onClick={handleIconClick}
                              sx={{
                                marginTop: '10px',
                                width: '100%',
                                height: '36px',
                                '& .MuiInputBase-root': {
                                  fontSize: '12px',
                                  height: '36px',
                                },
                                '& .MuiInputLabel-root': {
                                  fontSize: '12px',
                                },
                              }}
                              InputProps={{
                                readOnly: true,
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton onClick={handleIconClick} edge="end">
                                      <FileUploadOutlinedIcon style={{ fontSize: '15px' }} />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                            <input type="file" ref={fileInputRef} onChange={(event: any) => handleFileChange(event, val)} style={{ display: 'none' }} />
                            {validationErrors[val.Id] && (
                              <Typography sx={{ color: 'red', mt: 1, fontSize: '11px' }}>{validationErrors[val.Id]}</Typography>
                            )}
                          </div>
                        )}
                        {val.Question_Type__c === 'Linear Scale' && (
                          <div key={index} style={{ marginTop: '10px' }}>
                            <Typography sx={{ fontSize: '10.5px', fontWeight: 500 }}>
                              {val.Question_Label__c} {val.Is_Required__c && <span style={{ color: 'red' }}>*</span>}
                            </Typography>
                            <Slider
                              value={Number(linearScaleValues.find(item => item.Id === val.Id)?.value) || 1}
                              onChange={(e, newValue) => handleLinearScaleChange({ target: { value: String(newValue) } } as React.ChangeEvent<HTMLInputElement>, val)}
                              step={1}
                              marks
                              min={1}
                              max={10}
                              valueLabelDisplay="auto"
                              sx={{
                                marginTop: '10px',
                                width: '79%',
                                marginLeft: '1%',
                                '& .MuiSlider-thumb': {
                                  height: '16px',
                                  width: '16px',
                                },
                                '& .MuiSlider-valueLabel': {
                                  fontSize: '10px',
                                },
                              }}
                            />
                            {validationErrors[val.Id] && (
                              <Typography sx={{ color: 'red', mt: 1, fontSize: '11px' }}>{validationErrors[val.Id]}</Typography>
                            )}
                          </div>
                        )}
                      </>
                    );
                  })
                ) : (
                  <Typography sx={{ fontSize: '15px', fontWeight: 500, marginTop: '20px', textAlign: 'center' }}>
                    Feedback not available
                  </Typography>
                )}
              </Box>
              {serviceDataQuestion?.questionnaire !== null && serviceDataQuestion.length != 0 && (
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end', marginTop: '20px' }}>
                  <AppButton
                    size="small"
                    type="reset"
                    variant="text"
                    others={{
                      fontSize: '12px',
                      fontWeight: '500',
                      color: KenColors.ClientBlack2,
                      height: '36px',
                      marginRight: '10px', // Added space between buttons
                    }}
                    onClick={handleCancelClick}
                  >
                    <Typography
                      sx={{
                        '@media (min-width: 1280px) and (max-width: 1300px)': {
                          fontSize: '10px !important',
                        },
                      }}
                    >
                      Cancel
                    </Typography>
                  </AppButton>

                  <AppButton
                    size="small"
                    onClick={handleSubmit}
                    variant="contained"
                    others={{ fontSize: '12px', fontWeight: '500', padding: '12px', paddingInline: '30px', borderRadius: '8px', height: '36px' }}
                  >
                    <Typography
                      sx={{
                        '@media (min-width: 1280px) and (max-width: 1300px)': {
                          fontSize: '10px !important',
                        },
                      }}
                    >
                      Submit
                    </Typography>
                  </AppButton>
                </Box>
              )}
            </Card>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default EventFeedback;
